export class ReceivingLogSearch { 
    public constructor(init?: Partial<ReceivingLogSearch>) {
        Object.assign(this, init);
    }

    location: string = '';
    rowStart: number = 0;
    rowEnd: number = 199;
    sortColumn: string = 'ID';
    sortOrderDesc: boolean = true;
    searchArchiveTable: boolean= false;

    filterColumnParams?: { [key: string]: any };
}
